module.exports = __webpack_public_path__ + "img/software_icon5.92f665fe.png";